import type {
  CommandeOuverte,
  DashboardAlerte,
  DashboardResume,
  DashboardResumeKey,
  StatusTone,
} from "@/types/domain";

// ⚠️ PHASE 1 ONLY — valeurs temporaires, clairement étiquetées « MOCK » dans l'UI.
// La forme respecte exactement le contrat DashboardResume de GET /dashboard/resume
// afin que le branchement API se limite à remplacer cet objet par la réponse réelle.
// Aucun UUID du jeu de démonstration n'est présent ici.
export const MOCK_DASHBOARD_RESUME: DashboardResume = {
  po_recus_aujourdhui: 4,
  commandes_ouvertes: 12,
  commandes_a_verifier: 7,
  commandes_a_acheter: 3,
  commandes_a_preparer: 5,
  expediees_a_facturer: 2,
  factures_a_envoyer: 9,
  produits_stock_faible: 4,
  valeur_commandes_ouvertes: 118935,
  valeur_attente_fournisseur: 24500,
};

// Ton visuel par KPI (présentation uniquement, aucune règle métier).
export const KPI_TONES: Record<DashboardResumeKey, StatusTone> = {
  po_recus_aujourdhui: "info",
  commandes_ouvertes: "info",
  commandes_a_verifier: "attention",
  commandes_a_acheter: "attention",
  commandes_a_preparer: "info",
  expediees_a_facturer: "attention",
  factures_a_envoyer: "attention",
  produits_stock_faible: "critical",
  valeur_commandes_ouvertes: "neutral",
  valeur_attente_fournisseur: "neutral",
};

export const MOCK_ALERTES: DashboardAlerte[] = [
  { code: "STOCK_FAIBLE", message: "Stock sous le seuil minimal", severite: "critical", reference: "PRD-1042" },
  { code: "COMMANDE_A_VERIFIER", message: "Commande en attente de vérification", severite: "attention", reference: "CMD-2087" },
  { code: "FACTURE_BLOQUEE", message: "Facturation bloquée : écart de prix", severite: "critical", reference: "FAC-3311" },
  { code: "RECEPTION_RETARD", message: "Réception fournisseur en retard", severite: "attention", reference: "ACH-0455" },
  { code: "EXCEPTION_OUVERTE", message: "Exception opérationnelle non traitée", severite: "info", reference: "EXC-0012" },
];

export const MOCK_COMMANDES_OUVERTES: CommandeOuverte[] = [
  {
    id: "mock-1",
    numero_commande: "CMD-2087",
    numero_po_client: null,
    date_reception: "2026-07-02",
    statut: "A_VERIFIER",
    valeur_commande: 18420,
    client: { id: "mock-client-1", nom: "Carrière Nord-Est" },
  },
  {
    id: "mock-2",
    numero_commande: "CMD-2088",
    numero_po_client: null,
    date_reception: "2026-07-03",
    statut: "APPROUVE",
    valeur_commande: 6250,
    client: { id: "mock-client-2", nom: "Groupe Bétonex" },
  },
  {
    id: "mock-3",
    numero_commande: "CMD-2090",
    numero_po_client: null,
    date_reception: "2026-07-05",
    statut: "RESERVE",
    valeur_commande: 41390,
    client: { id: "mock-client-3", nom: "Mines Lauzon" },
  },
];
